import React from 'react';
import PropTypes from 'prop-types';
import FloatInput from './FloatInput';
import ClearRowButton from './ClearRowButton';

class NumberInputRow extends React.Component {
  render() {
    const { title,
      inputType,
      userPayrolls,
      onInputChange,
      onInputFocus,
      clz,
      manualMode,
      disabled,
      onClearRow,
      settingsBand
    } = this.props;

    // #2129: 設定セクションを他セクションと同じ「縦書き帯 + 項目名列」構成にするため、
    // settingsBand 指定時は項目名を th2(単一列)で出す(帯は親が別途描画)。
    // 既定/ネット行(clz="th1")の colSpan=2 は不変。
    const labelClz = settingsBand ? 'item th2' : `item ${clz || 'th2'}`;
    const labelColSpan = settingsBand ? '1' : (clz == 'th1' ? '2' : '1');

    return (
      <>
        <th className={labelClz} colSpan={labelColSpan}>
          {onClearRow ? (
            <ClearRowButton title={title} onClear={onClearRow} />
          ) : (
            <span>{title}</span>
          )}
        </th>
        {userPayrolls.map((userPayroll, index) => {
          let value = userPayroll[inputType] === 0 ? 0 : userPayroll[inputType] || '';

          // MEMO Fix value for Tax2024 manual mode;
          value = inputType.match(/^tax2024_/) && value === '' && userPayroll['tax2024_number_of_family_members'] !== null ? 0 : value;

          return (
            <td className="salary w9" key={index}>
              <FloatInput className="inputNumber w9"
                disabled={!disabled ? false : !manualMode ? true : value === ''}
                inputType={inputType}
                name={`payment[${userPayroll.uID}][${inputType}]`}
                onChange={(e) => onInputChange(e, index, inputType)}
                onFocus={(e) => onInputFocus(e, userPayroll.uID, inputType)}
                onImeWarning={this.props.onImeWarning}
                type="text"
                value={value}
              />
            </td>
          );
        })}
      </>
    );
  }
}

NumberInputRow.propTypes = {
  title: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  optionAttributes: PropTypes.array.isRequired,
  clz: PropTypes.string.isOptional,
  manualMode: PropTypes.bool.isOptional,
  disabled: PropTypes.bool.isOptional,
  onClearRow: PropTypes.func,
  onImeWarning: PropTypes.func,
  settingsBand: PropTypes.bool
};

export default NumberInputRow;
